import L from "leaflet";
import i18n from "@/i18n";
import {eventBus} from "@/main";

export function createMoveControl() {

    return L.Control.Button = L.Control.extend({
        options: {
            position: 'topright'
        },
        onAdd: (map) => {
            let container = L.DomUtil.create('div', 'button-19');

            let button = L.DomUtil.create('input', 'button-18', container);
            button.value = "←";
            button.type = "button";
            button.title = i18n.t('map.movePointLeft')
            L.DomEvent.disableClickPropagation(button);

            L.DomEvent.on(button, 'click', () => {
                this.moveWaypoint(270);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "↑";
            button.type = "button";
            button.title = i18n.t('map.movePointUp')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.moveWaypoint(0);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "↓";
            button.type = "button";
            button.title = i18n.t('map.movePointDown')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.moveWaypoint(180);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "→";
            button.type = "button";
            button.title = i18n.t('map.movePointRight')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.moveWaypoint(90);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "↤";
            button.type = "button";
            button.title = i18n.t('map.moveLegLeft')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.moveLeg(270);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "↥";
            button.type = "button";
            button.title = i18n.t('map.moveLegUp')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.moveLeg(0);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "↧";
            button.type = "button";
            button.title = i18n.t('map.moveLegDown')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.moveLeg(180);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "↦";
            button.type = "button";
            button.title = i18n.t('map.moveLegRight')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.moveLeg(90);
            });

            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "✥";
            button.type = "button";
            button.title = i18n.t('map.movePoint')
            L.DomEvent.on(button, 'pointerup', (e) => {
                e.target.releasePointerCapture(e.pointerId);
                const waypointIndex = this.selectedWaypointIndex;
                if (waypointIndex < 0) return;

                this.changeWaypointCoordinates(waypointIndex, this.map.getCenter(), true);
            });
            L.DomEvent.on(button, 'pointerdown', (e) => {
                e.target.setPointerCapture(e.pointerId);
            });
            
            button = L.DomUtil.create('input', 'button-18', container);
            button.value = "×";
            button.type = "button";
            button.title = i18n.t('map.removePoint')
            L.DomEvent.disableClickPropagation(button);
            L.DomEvent.on(button, 'click', () => {
                this.deleteWaypoint();
            });

            return container;
        },
        onRemove: function (map) {
        },
    });
}

export function createWPControl() {

    return L.Control.Button = L.Control.extend({
        options: {
            position: 'topright'
        },
        onAdd: (map) => {
            eventBus.$off('wp-control-select-wp', map);
            eventBus.$on('wp-control-select-wp', (index) => {
                button2.value = (index === undefined || index === null || index < 0) ? ' ' : "WP" + index
            })

            let container = L.DomUtil.create('div', 'button-17');

            let button1 = L.DomUtil.create('input', 'button-15', container);
            button1.value = "<";
            button1.type = "button";
            button1.title = "previous point"
            L.DomEvent.disableClickPropagation(button1);
            L.DomEvent.on(button1, 'click', () => {
                this.changeSelectedWaypoint('left')
                map.closePopup();
            });

            let button2 = L.DomUtil.create('input', 'button-16', container);
            button2.value = " ";
            button2.type = "button";
            button2.style.display = 'inline'
            L.DomEvent.disableClickPropagation(button2);
            L.DomEvent.on(button2, 'click', () => {
            });

            let button3 = L.DomUtil.create('input', 'button-15', container);
            button3.value = ">";
            button3.type = "button";
            button3.title = "next point"
            L.DomEvent.disableClickPropagation(button3);
            L.DomEvent.on(button3, 'click', () => {
                this.changeSelectedWaypoint('right')
                map.closePopup();
            });

            return container;
        },
        onRemove: function (map) {
        },
    });
}

export function createClearControl() {
    return L.Control.extend({
        options: {
            position: 'topright'
        },

        onAdd: (map) => {
            eventBus.$on('language-changed', () => {
                container.title = i18n.t('map.clearRouteHint');
                container.value = i18n.t('map.clearRoute')
            })

            let container = L.DomUtil.create('input');
            container.type = "button";
            container.className = "button-14";
            container.title = i18n.t('map.clearRouteHint');
            container.value = i18n.t('map.clearRoute');

            container.onclick = (e) => {
                e.stopPropagation();
                e.preventDefault();
                map.closePopup();
                this.clearRoute();
                this.clearGeneralRoute();
                this.drawMapLayers();
            }
            return container;
        },
        onRemove: (map) => {
        }
    })
}

export function createCheckSafetyControl() {
    return L.Control.extend({
        options: {
            position: 'topright'
        },

        onAdd: (map) => {
            eventBus.$off('wp-control-toggle-check-safety', map);
            eventBus.$on('wp-control-toggle-check-safety', (isNeedCheck) => {
                if (isNeedCheck) {
                    eventBus.$emit('switch-wp-tab')
                    eventBus.$emit('is-need-check-safety', true)
                    L.DomUtil.addClass(container, "button-20");
                    L.DomUtil.removeClass(container, "button-14");
                    this.isCheckSafetyControlFired = true;
                } else {
                    L.DomUtil.addClass(container, "button-14");
                    L.DomUtil.removeClass(container, "button-20");
                    eventBus.$emit('is-need-check-safety', false)
                    this.isCheckSafetyControlFired = false
                }
            })

            let container = L.DomUtil.create('input');

            eventBus.$on('language-changed', () => {
                container.title = i18n.t('map.checkRouteSafetyHint');
                container.value = i18n.t('map.checkRouteSafety')
            })

            container.type = "button";
            container.className = "button-14";
            container.title = i18n.t('map.checkRouteSafetyHint');
            container.value = i18n.t('map.checkRouteSafety');
            container.style.display = 'inline'

            container.onclick = (e) => {
                e.stopPropagation();
                e.preventDefault();
                map.closePopup();
                this.checkSafety();
            }
            return container;
        },
        onRemove: (map) => {
        }
    })
}

export function createSafetyControl() {
    return L.Control.extend({
        options: {
            position: 'topright'
        },

        onAdd: (map) => {
            let container = L.DomUtil.create('input');
            container.type = "button";
            container.title = i18n.t('map.checkRouteSafetyHint');
            container.value = i18n.t('map.checkRouteSafety');
            container.className = "button-14";

            container.onclick = (e) => {
                e.stopPropagation();
                e.preventDefault();
                map.closePopup();
                eventBus.$emit('check-safety')
            }
            return container;
        }
    })
}

export function createNOGOTextBox() {
    let textbox = L.Control.extend({
        onAdd: function () {

            var text = L.DomUtil.create('div');
            text.id = "nogo_text";
            text.innerHTML = "<p>NOGO: m</p>"
            return text;
        },
        updateContent: function (text) {
            this.getContainer().innerHTML = text;
        }

    });
    return new textbox({position: 'topleft'})
}


export function createMakeNoGoControl() {
    return L.Control.extend({
        options: {
            position: 'topleft'
        },

        onAdd: (map) => {
            eventBus.$off('toggle-mode-after-auto')
            eventBus.$on('toggle-mode-after-auto', () => {
                container.button_state = true
                container.value = i18n.t('map.editNoGoZones');
            })

            eventBus.$on('language-changed', () => {
                container.value = container.button_state ?
                    i18n.t('map.editNoGoZones') :
                    i18n.t('map.exitEditing');
            })

            let container = L.DomUtil.create('input');
            container.button_state = true;
            container.type = "button";
            container.title = "Toggle ";
            container.value = i18n.t('map.editNoGoZones');
            container.className = "button-13"
            container.onclick = (e) => {

                e.stopPropagation();
                e.preventDefault();
                container.button_state = !container.button_state;
                map.closePopup();

                this.toggleNoGoMode(container.button_state);

                if (container.button_state)
                    this.saveNoGoZones();
                
                container.value = container.button_state ? i18n.t('map.editNoGoZones') : i18n.t('map.exitEditing');
            }
            return container;
        }
    });
}

export function createMakeNavRouteControl() {
       return L.Control.extend({
        options: {
            position: 'topright'
        },

        onAdd: (map) => {
            eventBus.$on('language-changed', () => {
                container.value = i18n.t('map.makeNavRoute')
            })

            let container = L.DomUtil.create('input');
            container.type = "button";
            container.className = "button-21";
            container.value = i18n.t('map.makeNavRoute');

            container.onclick = (e) => {
                e.stopPropagation();
                e.preventDefault();
                map.closePopup();
                this.makeRouteFromPreview();
            }
            return container;
        }
    });
 
}